<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR ATA' : 'NOVA ATA'" titleIcon="fas fa-scroll">
            <el-form label-position="top" :model="form" ref="formRef" @submit.native.prevent="salvar">
                <el-row :gutter="10" v-if="precisaSelecionarInstituicao">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Instituição" prop="instituicao_id" :rules="[$requiredChange]">
                            <el-select v-model="form.instituicao_id" filterable placeholder="Selecione a instituição" style="width:100%;">
                                <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Título" prop="titulo" :rules="[$requiredBlur]">
                            <el-input v-model="form.titulo" maxlength="255" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Nº">
                            <el-input v-model="form.numero" maxlength="60"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Data" prop="data_ata" :rules="[$requiredBlur]">
                            <el-date-picker v-model="form.data_ata" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Tipo">
                            <el-select v-model="form.tipo_ata_id" filterable clearable style="width:100%;">
                                <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Local">
                            <el-input v-model="form.local"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Participantes">
                            <el-input v-model="form.participantes" placeholder="Lista textual"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Conteúdo da ata">
                    <ckeditor v-model="form.conteudo" :config="ckeditorConfig"></ckeditor>
                </el-form-item>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/ata"><el-button>VOLTAR</el-button></router-link>
                        <el-button class="u-ml-10" v-if="modoEdicao && !form.finalizada" type="warning" plain @click="finalizar">FINALIZAR</el-button>
                        <el-button class="u-ml-10" v-if="modoEdicao && form.finalizada" type="warning" plain @click="reabrir">REABRIR</el-button>
                        <el-button class="u-ml-10" type="primary" native-type="submit" :disabled="form.finalizada">SALVAR</el-button>
                    </el-col>
                </el-row>

                <p v-if="form.finalizada" style="color:#67c23a; margin-top:8pt;">
                    <i class="el-icon-circle-check"></i> Esta ata está finalizada. Clique em REABRIR para editar.
                </p>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
import ckeditor from '@/shared/ckeditor/ckeditor'
export default {
    components: { ckeditor },
    data () {
        return {
            form: this.formVazio(),
            modoEdicao: false,
            tipos: [],
            ckeditorConfig: { height: 320 }
        }
    },
    computed: {
        // Perfis vinculados (secretário, diretor, etc.) já têm a instituição do login.
        // SMED/NTI não têm vínculo (config.instituicao = false) e precisam selecionar.
        precisaSelecionarInstituicao () {
            const inst = this.$store.state.config.instituicao
            return !inst || !inst.id
        }
    },
    mounted () {
        this.carregarTipos()
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        } else {
            this.form.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
        }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        formVazio () {
            return {
                instituicao_id: null, tipo_ata_id: null,
                periodo_letivo_id: null, turma_id: null,
                numero: '', titulo: '', data_ata: null,
                local: '', participantes: '', conteudo: '',
                finalizada: false
            }
        },
        carregar (id) {
            this.$axios.get(`${this.baseUrl()}/api/ata/getById/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                const reg = r.data || {}
                Object.keys(this.form).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.form[k] = reg[k] })
            }).catch(e => this.$store.commit('throwException', e))
        },
        carregarTipos () {
            this.$axios.post(`${this.baseUrl()}/api/tipo-ata/getAllPaginate`, { situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = (r.data && r.data.data) ? r.data.data : (r.data || []) })
        },
        salvar () {
            this.$refs.formRef.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.baseUrl()}/api/ata/update/${this.$route.params.id}`
                    : `${this.baseUrl()}/api/ata/store`
                this.$axios.post(url, this.form, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo.', type: 'success' })
                    this.$router.push('/admin/ata')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        finalizar () {
            this.$confirm('Após finalizar, a ata fica somente leitura. Confirmar?', 'Finalizar', { type: 'warning' }).then(() => {
                this.$axios.post(`${this.baseUrl()}/api/ata/finalizar/${this.$route.params.id}`, {}, this.$store.getters.getHeaderAuth).then(() => {
                    window.eventBus.$emit('alert', { msg: 'Ata finalizada.', type: 'success' })
                    this.form.finalizada = true
                })
            }).catch(() => {})
        },
        reabrir () {
            this.$axios.post(`${this.baseUrl()}/api/ata/reabrir/${this.$route.params.id}`, {}, this.$store.getters.getHeaderAuth).then(() => {
                window.eventBus.$emit('alert', { msg: 'Ata reaberta.', type: 'success' })
                this.form.finalizada = false
            })
        }
    }
}
</script>
